import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../config/axiosConfig";
import { TYPE_FRAIS_URL } from "../../settings/APISetting";
import { sortByProp } from "../../settings/themeSettings";

export const fetchTypeFrais = createAsyncThunk('fetch-type-frias', async (page = 1) => {
    const response = await api.get(TYPE_FRAIS_URL);
    return response.data;
});

export const createTypeFrais = (typeFrais, err, cb) => {
    api.post(TYPE_FRAIS_URL, typeFrais)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const updateTypeFrais = (typeFrais, err, cb) => {
    api.put(`${TYPE_FRAIS_URL}/${typeFrais.id}`, typeFrais)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const deleteTypeFrais = (id, err, cb) => {
    api.delete(`${TYPE_FRAIS_URL}/${id}`)
        .then((response) => {
            if (cb) cb(response);
        })
        .catch((error) => {
            if (err) err(error);
        });
}




const typeFraisSlice = createSlice({

    name: 'typeFrais',
    initialState: { typeFrais: [], typeFraisFetchStatus: '' },

    reducers: {
        addTypeFrais: (state, action) => {
            state.typeFrais = [...state.typeFrais, action.payload].sort((a, b) => sortByProp(a, b, 'libelle'));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTypeFrais.fulfilled, (state, action) => {
            if (Array.isArray(action.payload)) {
                state.typeFrais = [...action.payload].sort((a, b) => sortByProp(a, b, 'libelle'));
                state.typeFraisFetchStatus = 'success';
            } else {
                console.error("fetchTypeFrais payload is not an array:", action.payload);
                state.typeFrais = [];
                state.typeFraisFetchStatus = 'error';
            }
        }).addCase(fetchTypeFrais.pending, (state, action) => {
            state.typeFraisFetchStatus = 'loading';

        }).addCase(fetchTypeFrais.rejected, (state, action) => {

            state.typeFraisFetchStatus = 'error';

        });
    }


});
export const { addTypeFrais } = typeFraisSlice.actions;
export default typeFraisSlice;